import { render, staticRenderFns } from "./MostSharedMedia.vue?vue&type=template&id=4c9837f8&"
import script from "./MostSharedMedia.vue?vue&type=script&lang=js&"
export * from "./MostSharedMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports